import React from 'react';

export const ENVIRONMENT = process.env.APP_ENV;
export const RELEASE_VERSION = process.env.RELEASE;

// Client Identification
export const SITE_ID = 1; // GlassesUSA
export const DEVELOP_CLIENT_ID = process.env.CLIENT_ID;
export const PRODUCTION_CLIENT_ID = '04a1379c-bdb0-4e33-a2b8-190d7cb85ad7'; // todo Mary why not from env?
export const CLIENT_ID = ENVIRONMENT === 'production' ? PRODUCTION_CLIENT_ID : DEVELOP_CLIENT_ID;
export const OAUTH_COOKIE_KEY = 'oAuthData';
export const IMPACT_RADIUS_COOKIE_KEY = 'impactRadius';

export const HELP_WORK_HOURS = 'Every day 7am - midnight ET';
export const HELP_WORK_HOURS_PDP = (
    <>
        Every day
        <br />
        7am - midnight ET
    </>
);
